export default {
  name: "catalog-hero",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    // Стильовий варіант hero. "outlet" — full-bleed банер як на старому /catalog?categories=outlet.
    variant: {
      type: String,
      default: "",
    },
    // Що рендерити:
    // "full" — title + опис + банер разом (дефолт; /collection/mens-health, /outlet);
    // "head" — title (H1) + опис над каталогом;
    // "tail" — банер під каталогом.
    // Для брендів hero розбито на head (зверху) + tail (під каталогом).
    mode: {
      type: String,
      default: "full",
    },
  },
  data() {
    return {
      expanded: false,
      isOverflowing: false,
    };
  },
  mounted() {
    this.checkOverflow();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    descriptionText() {
      this.expanded = false;
      this.$nextTick(this.checkOverflow);
    },
  },
  computed: {
    showTitle() {
      return this.mode === "full" || this.mode === "head";
    },
    showDescription() {
      return this.mode === "full" || this.mode === "head";
    },
    showDetails() {
      return this.mode === "full" || this.mode === "tail";
    },
    headingText() {
      if (!this.data) return "";
      return this.data.title || this.data.metaTitle || "";
    },
    descriptionText() {
      if (!this.data) return "";
      return this.data.description || "";
    },
    bannerSrc() {
      if (!this.data) return "";
      // Тільки реальний banner_image. Без fallback на `image` (це generic-зображення
      // бренду, не банер) — якщо банера нема, блок банера не рендериться (graceful degradation).
      return this.data.bannerImage || "";
    },
    hasTitle() {
      return this.showTitle && !!this.headingText;
    },
    hasDescription() {
      return this.showDescription && !!this.descriptionText;
    },
    hasBanner() {
      return this.showDetails && !!this.bannerSrc;
    },
    hasContent() {
      return this.hasTitle || this.hasDescription || this.hasBanner;
    },
  },
  methods: {
    checkOverflow() {
      const container = this.$refs.description;
      if (!container) {
        this.isOverflowing = false;
        return;
      }
      this.isOverflowing = container.scrollHeight > container.clientHeight;
    },
    onResize() {
      if (!this.expanded) this.checkOverflow();
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
};
